import { render, staticRenderFns } from "./SubscriptionTypeForm.vue?vue&type=template&id=321787f4&"
import script from "./SubscriptionTypeForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports